module.exports = __webpack_public_path__ + "static/media/company-logo.d2fe6e8b.png";